export const taskDataCalc = costLevel => {
    const data = {
        budget: 0,
        steps: 0,
        earned: 0,
    };
    switch (costLevel) {
        case 'very low':
            data.budget = 100;
            data.steps = 0;
            data.earned = 400;
            break;
        case 'low':
            data.budget = 200;
            data.steps = 0;
            data.earned = 1000;
            break;
        case 'standard':
            data.budget = 200;
            data.steps = 1;
            data.earned = 1400;
            break;
        case 'medium':
            data.budget = 300;
            data.steps = 2;
            data.earned = 2000;
            break;
        case 'high':
            data.budget = 500;
            data.steps = 3;
            data.earned = 3200;
            break;
        default:
            data.budget = 500;
            data.steps = 3;
            data.earned = 3200;
            break;
    }
    return data;
};

export const taskSourcesCalc = costLevel => {
    const sources = {
        white: 0,
        red: 0,
        green: 0,
    };
    switch (costLevel) {
        default:
        case 'very low':
            sources.white = 1;
            sources.red = 0;
            sources.green = 0;
            break;
        case 'low':
            sources.white = 3;
            sources.red = 0;
            sources.green = 0;
            break;
        case 'standard':
            sources.white = 3;
            sources.red = 1;
            sources.green = 0;
            break;
        case 'medium':
            sources.white = 0;
            sources.red = 1;
            sources.green = 1;
            break;
        case 'high':
            sources.white = 2;
            sources.red = 2;
            sources.green = 1;
            break;
    }
    return sources;
};

export const orSourcesCalc = sources => {
    const newSources = { ...sources };
    Object.keys(newSources).map(currentKey => {
        if (newSources[currentKey] > 0) newSources[currentKey]--;
    });
    return newSources;
};

export const orDataCalc = data => {
    const newData = { ...data };
    newData.steps++;
    if (data.budget >= 100) newData.budget = Math.max(100, data.budget - 100);
    else newData.budget = data.budget;
    newData.earned = data.earned * 0.5;
    return newData;
};
